/* eslint-disable */
/* ***********************************************************
* A short word on how to use this automagically generated file.
* We're often asked in the ignite gitter channel how to connect
* to a to a third party api, so we thought we'd demonstrate - but
* you should know you can use sagas for other flow control too.
*
* Other points:
*  - You'll need to add this saga to sagas/index.js
*  - This template uses the api declared in sagas/index.js, so
*    you'll need to define a constant in that file.
*************************************************************/

import { call, put, select, take, fork, cancel, cancelled } from 'redux-saga/effects'
import KargoeTagActions from '../Redux/KargoeTagRedux'
import index from '../Redux';
// import { KargoeTagSelectors } from '../Redux/KargoeTagRedux'
const userPostss = (state) => state.postPeople
function* getKargoeTagAsyn(api, action) {
  try {


    const { data: { limit = 10, search = "", filter = ""   } } = action

    const responseKargoe = yield call(api.getKargoeTag, { limit, search, filter })
    if(action.data && action.data.noPost && action.data.noPost == true){
      yield put(KargoeTagActions.kargoeTagSuccess(responseKargoe))
    }else{
      for (var i = 0; i < responseKargoe.data.data.length; i++) {
        let item = responseKargoe.data.data[i]
  
        const responseItem = yield call(api.getPostByItem, item)
        responseKargoe.data.data[i].Posts = responseItem.data.data
  
  
        if (responseKargoe.ok) {
  
          yield put(KargoeTagActions.kargoeTagSuccess(responseKargoe))
        } else {
          yield put(KargoeTagActions.kargoeTagFailure())
        }
      }
    }
   




  } catch (e) {
    console.tron.display({
      name: 'getKargoeTag error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  } finally {
    if (yield cancelled())
      yield put(KargoeTagActions.kargoeTagFailure())
  }

}
export function* getKargoeTag(api, action) {

  // starts the task in the background
  const bgSyncTask = yield fork(getKargoeTagAsyn, api, action)

  // wait for the user stop action
  yield take('KARGOE_TAG_SEARCH_REQUEST')
  // user clicked stop. cancel the background task
  // this will cause the forked bgSync task to jump into its finally block
  yield cancel(bgSyncTask)

}
export function* getSearchTag(api, action) {
  try {

    const { data } = action

    const responseKargoe = yield call(api.getSearchKargoeTag, data)
    if (responseKargoe.ok) {
      if(responseKargoe.data.data.length > 0){
        if(data.noPost && data.noPost == true){
          yield put(KargoeTagActions.kargoeTagSearchSuccess(responseKargoe))
        }else{
          for (var i = 0; i < responseKargoe.data.data.length; i++) {
            let item = responseKargoe.data.data[i]
          
            const responseItem = yield call(api.getPostByItem, item)
            if (responseItem.ok) {
              responseKargoe.data.data[i].Posts = responseItem.data.data
           
    
              responseKargoe.search = data.search
              yield put(KargoeTagActions.kargoeTagSearchSuccess(responseKargoe))
            } else {
              yield put(KargoeTagActions.kargoeTagSearchFailure())
            }
        }
       
  
        }
      }else{
        yield put(KargoeTagActions.kargoeTagSearchSuccess(responseKargoe))
      }
     
    } else {
      console.tron.display({
        name: 'getKargoeTag error',
        preview: "expand",
        value: {
          message: e.message,
          e: e
        }
      })
      yield put(KargoeTagActions.kargoeTagSearchFailure())
    }





  } catch (e) {
    console.tron.display({
      name: 'getKargoeTag error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
  }

}


export function* searchItems(api, action) {
  // plain search through Kargoe items, no linked ItemPosts loaded
  try {
    const { data } = action
    const responseKargoe = yield call(api.getSearchKargoeTag, data)
    if (responseKargoe.ok)
      yield put(KargoeTagActions.kargoeTagSearchSuccess(responseKargoe))
    else
      yield put(KargoeTagActions.kargoeTagSearchFailure())
  } catch (e) {
    console.tron.display({
      name: 'searchItems error',
      preview: "expand",
      value: {
        message: e.message,
        e: e
      }
    })
    yield put(KargoeTagActions.kargoeTagSearchFailure())
  }
}
